import UpsertWatchListEntryFormHighRiskCountry from './UpsertWatchListEntryFormHighRiskCountry';

export default UpsertWatchListEntryFormHighRiskCountry;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/upsert-watch-list-entry-form/index.js